import { GlobalContextContract } from 'context/GlobalContext'
import { GlobalContext } from 'context/GlobalContext'
import { useContext } from 'react'

export function useGlobalContext(): GlobalContextContract {
  return useContext<GlobalContextContract>(GlobalContext)
}
